import { RigRateBase } from './base/rig-rate-base';

export class RigRate extends RigRateBase { }